import boletaApi from "./boletaApi";

export const deleteInvoice = async (body) => {
  try {
    return await boletaApi.post("/deleteInvoice", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
